import styled from 'styled-components';
import Colors from '../../../themes/Colors';

const ModalContentHolder = styled.div`
  padding: 10px;
  min-height: 300px;
  .general-skeleton {
    padding: 10px;
    text-align: center;
  }

  .contentCardContent {
    text-align: center;
    padding: 10px;
  }
  .infoTitle {
    font-size: 16px;
    font-weight: bold;
    color: ${Colors.textStrong};
    margin-bottom: 12px;
  }

  .infoCol {
    display: flex;
    align-items: flex-start;
    color: ${Colors.coal};
    font-size: 14px;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid ${Colors.border};
  }

  .infoCol:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: none;
  }

  .infoCol .infoIcon {
    font-size: 20px;
    color: ${Colors.primaryAccent};
    margin-right: 10px;
    margin-top: 2px;
  }

  .infoCol .infoText {
    flex: 1;
    min-width: 0;
  }

  .infoCol .label {
    font-weight: bold;
    margin-bottom: 3px;
  }

  .infoCol .value {
    color: ${Colors.primaryAccent};
    word-break: break-word;
  }

  .infoCol .editIcon {
    margin-left: 8px;
    cursor: pointer;
  }
  @media (max-width: 1200px) {
    .content-info-bunlde {
      border-left: 0px !important;
    }
    .content-map-bunlde {
      margin-bottom: 30px;
    }
  }
  .content-info-bunlde {
    height: 100%;
    border-left: 1px solid #aaa;
    padding-left: 15px;
  }
`;

export default ModalContentHolder;
